import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'featureFlag'
})
export class FeatureFlagPipe implements PipeTransform {

  transform(value: any): boolean {
    const featureFlags = sessionStorage.getItem('feature-flags');
    if (featureFlags) {
      const decodedFeatureFlags = JSON.parse(atob(featureFlags));
      if (decodedFeatureFlags.includes(value)) {
        return true;
      }
    }
    return false;
  }

}
